<button class="notification-item" (click)="notificationClicked()" type="button">
    <a [routerLink]="notification().routerLinkCommands">
        <svg-icon alt="notification" [src]="notification().icon" svgClass="icon"></svg-icon>
        <span class="notification-text">{{notification().text}}</span>
    </a>
</button>
